import React from 'react';
import Config from '../utils/config';
import {getFullUrlPath} from '../utils/common'; 

export default class PopupTurnMobile extends React.Component {
	state = {
		Msg_TurnToMobileTitle: '',
		Msg_TurnToMobile: '',
		Msg_TurnToMobileCheck: '',
		lbl_yes: '',
		lbl_no: '',
		SaveCookie: false
	};

	popupDiv(type) {
		this.props.popupDiv(type);
	}

	SenConfirm(isturntoMobile) {
		const savecookie = this.state.SaveCookie;
		if (savecookie) {
			setCookie('isturntoMobile', isturntoMobile, null, null, Config.appConfig.DomainName);
		} else {
			setCookie('isturntoMobile', isturntoMobile, 1, null, Config.appConfig.DomainName);
		}
		if (isturntoMobile == 'false') {
			this.popupDiv(-1);
		} else {
			location.replace('//smart.' + Config.appConfig.DomainName + '/');
		}
		return;
	}

	componentDidMount() {
		// var self = this;
		$.ajax({
			url: getFullUrlPath('getOption.ashx?setPara=mobile'),
			dataType: 'json',
			async: false,
			success: data => {
				this.setState({
					Msg_TurnToMobileTitle: data.Msg_TurnToMobileTitle,
					Msg_TurnToMobile: data.Msg_TurnToMobile,
					Msg_TurnToMobileCheck: data.Msg_TurnToMobileCheck,
					Msg_Yes: data.Msg_Yes,
					Msg_No: data.Msg_No
				});
			}
		});
	}

	render() {
		return (
			<div className="blocker">
				<div className="modal popup-mobile">
					<a
						href="javascript:void(0);"
						onClick={this.popupDiv.bind(this, -1)}
						title="Close"
						className="close"
					>
						<i className="icon-close" />
					</a>
					<h2>{this.state.Msg_TurnToMobileTitle}</h2>
					<div>
						<h3>
							{this.state.Msg_TurnToMobile}
							<br />
							<br />
							<label for="CheckTerm" className="small-input">
								<input
									type="checkbox"
									name="SaveCookie"
									value="SaveCookie"
									className=""
									id="SaveCookie"
									checkedLink={this.linkState('SaveCookie')}
								/>
								<div className="txt">{this.state.Msg_TurnToMobileCheck}</div>
							</label>
						</h3>
						<div className="btn-group btn-lg">
							<a id="yesConfirm" name="yesConfirm" onClick={this.SenConfirm.bind(this, 'true')}>
								{this.state.Msg_Yes}
							</a>
							<a id="noConfirm" name="noConfirm" onClick={this.SenConfirm.bind(this, 'false')}>
								{this.state.Msg_No}
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
